import { getPath } from '@/router/common'

const baseUrl = {
  title: '线路打印设置',
  path: 'LinePrintSetting'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'linePrintSettingIndex',
    component: () => import(/* webpackChunkName: "linePrintSettingIndex" */ '@/views/LinePrintSetting/index/index.vue'),
    meta: {
      title: '线路打印设置'
    }
  },
  {
    path: getPath('AddOrEdit', baseUrl),
    name: 'LinePrintSettingAddOrEdit',
    component: () => import(/* webpackChunkName: "AddOrEdit" */ '@/views/LinePrintSetting/AddOrEdit/index.vue'),
    meta: {
      title: '用户打印模板新增'
    }
  }
]
